import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-success",
  "use": "icon-icon-success-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-icon-success\">\r\n<g>\r\n\t<circle fill=\"#14BA0F\" cx=\"8\" cy=\"8\" r=\"8\" />\r\n\t<g>\r\n\t\t<g>\r\n\t\t\t<path fill=\"#FFFFFF\" d=\"M6.526,11.578c-0.109,0-0.219-0.042-0.303-0.126l-3.35-3.351c-0.168-0.168-0.168-0.438,0-0.605\r\n\t\t\t\tc0.167-0.168,0.439-0.168,0.607,0l3.045,3.046l5.996-5.994c0.168-0.168,0.438-0.168,0.605,0c0.168,0.169,0.168,0.439,0,0.606\r\n\t\t\t\tl-6.298,6.298C6.747,11.536,6.636,11.578,6.526,11.578z\" />\r\n\t\t</g>\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-success.svg
// module id = 5MPy
// module chunks = 39